import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './components/Home';
import Properties from './components/Properties';
import AddProperty from './components/AddProperty';
import PropertyDetails from './components/PropertyDetails';
import Dashboard from './components/Dashboard';
import Auth from './components/Auth';
import AdminLogin from './components/AdminLogin';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminDashboard from './components/AdminDashboard';
import UserProfile from './components/UserProfile';
import ContactModal from './components/ContactModal';
import SeedDatabase from './components/SeedDatabase'; // 1. Yahan import add kiya

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const handleOpenContact = () => setIsContactModalOpen(true);
  const handleCloseContact = () => setIsContactModalOpen(false);

  return (
    <Router>
      <div className="min-h-screen bg-slate-50 text-slate-900 flex flex-col justify-between">
        <div>
          <Navbar onOpenContact={handleOpenContact} />
          
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/properties" element={<Properties />} />
            <Route path="/property/:id" element={<PropertyDetails />} />
            
            {/* Auth Routes */}
            <Route path="/auth" element={<Auth />} />            
            <Route path="/admin-login" element={<AdminLogin />} />   

            {/* General Pages */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/profile" element={<UserProfile />} />
            
            {/* 2. Temporary Seed Route jisse button show hoga */}
            <Route path="/seed" element={<SeedDatabase />} />

            {/* Admin Protected Route */}
            <Route 
              path="/admin" 
              element={
                <AdminRoute>
                  <AdminDashboard />
                </AdminRoute>
              } 
            />
            
            {/* User Protected Routes */}
            <Route 
              path="/add-property" 
              element={
                <ProtectedRoute>
                  <AddProperty />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </div>
        
        <Footer />

        <ContactModal 
          isOpen={isContactModalOpen} 
          onClose={handleCloseContact} 
        />
      </div>
    </Router>
  );
}

export default App;